import { render, staticRenderFns } from "./V2CollectionCard.vue?vue&type=template&id=326be644&scoped=true&"
import script from "./V2CollectionCard.vue?vue&type=script&lang=js&"
export * from "./V2CollectionCard.vue?vue&type=script&lang=js&"
import style0 from "./V2CollectionCard.vue?vue&type=style&index=0&id=326be644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326be644",
  null
  
)

export default component.exports